import {useCallback} from "react";
import {call} from "redux-saga/effects";

import {useSagaCallback} from "../store/sagas";
import {apiPost} from "./client";

export const useSetEmail = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (password, email) {
        yield call(apiPost, `/api/v2/user/email`, {
            password,
            email
        });
    }, []))
};